import { render, staticRenderFns } from "./PdfViewer.vue?vue&type=template&id=57560365&v-else=true&lang=pug&"
import script from "./PdfViewer.vue?vue&type=script&lang=ts&"
export * from "./PdfViewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57560365')) {
      api.createRecord('57560365', component.options)
    } else {
      api.reload('57560365', component.options)
    }
    module.hot.accept("./PdfViewer.vue?vue&type=template&id=57560365&v-else=true&lang=pug&", function () {
      api.rerender('57560365', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/PdfViewer.vue"
export default component.exports